import { useState ,useEffect} from "react";
import Adminapp from "./component/adminapp";
import UserModule from "./user/userapp";

function App() {
  //  const [loggedIn, setLoggedIn] = useState(false); 

  
  //   if (localStorage.getItem("sellerid") == null){
  //     return(<UserModule loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>);
  // }
  
  // else{
  //     return (<Adminapp/>);


  // }

  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("loggedIn") === "true"
  );

  useEffect(() => {
    // Store the login status in localStorage
    localStorage.setItem("loggedIn", loggedIn);
  }, [loggedIn]);
 return(
  <>
  {
   (loggedIn?(<Adminapp/>):(<UserModule  loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>))
 }

 </>


 )
  
}

export default App;